/**
 * 作品ごとのバックエンド種別マッピング
 *
 * "system" — system/ (port 5002, /api/v1/..., DynamoDB)
 * "app"    — app/    (port 5001, /api/..., PostgreSQL)
 */
export const WORK_BACKEND = {
  potion: "system",
  yofukashi: "app",
  chi: "app",
  higurashi: "app",
  jashindp: "app",
  irene: "app",
};

/**
 * 指定した作品が system/ バックエンドを使うかどうかを返す
 */
export const isSystemWork = (work) =>
  WORK_BACKEND[work] === "system";
